'use strict';

const progress = require('../../progress');
const toAbsoluteUrl = require('../../modules/util/toAbsoluteUrl');
const appendParamToURL = require('../../modules/util/appendParamToURL');

const currentRequests = [];

/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 * @param {Boolean} replaceTarget If true, the target element will be completely replaced with new content
 */
const load = (options) => {
    options.url = toAbsoluteUrl(options.url);

    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'html',
        url: appendParamToURL(options.url, 'format', 'ajax'),
        data: options.data,
        traditional: true,
        xhrFields: {
            withCredentials: true
        }
    })
    .done((response) => {
        // success
        if (options.target) {
            if (options.replaceTarget) {
                $(options.target).replaceWith(response);
            } else {
                $(options.target).empty().html(response);
            }
        }
        if (options.callback) {
            options.callback(response, options.dialogTarget);
        }
    })
    .fail((xhr, textStatus) => {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        options.callback(null, textStatus);
    })
    .always(() => {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

module.exports = load;
